import { FindyLogoLink } from '../../components/findy-logo-link.component';
import { HamburgerMenu } from '../../components/hamburger-menu/hamburger-menu.component';
import { SignUpLink } from '../components/sign-up-link.component';
import { PublicHamburgerMenuList } from './public-hamburger-menu-list.component';
import styles from './public-mobile-content.component.module.scss';

type Props = {
  pathname: string;
};

export const PublicMobileContent = ({ pathname }: Props) => {
  return (
    <div className={styles.wrapper}>
      <HamburgerMenu>
        <PublicHamburgerMenuList pathname={pathname} />
      </HamburgerMenu>
      <FindyLogoLink align="center" to="/" />
      <SignUpLink />
    </div>
  );
};
